<div *ngIf="showAlertBeforeExit" class="print-history-popup">
  <div class="print-history-popup-body">
    <h2 class="popup-title" style="text-align: center; ">
     ביצעת שינויים שלא נשמרו 
  </h2>
    <button
      (click)="showAlertBeforeExit = false"
      class="print-history-popup-close"
      aria-label="close popup"
    ></button>
    <div style="display: flex; flex-direction: row;justify-content: space-between; margin-top: 1em;">
      <button class="btn-cancel"  (click)="goToCalendar()" >
        {{'appointments.gui.buttons.Leave without saving' | translate}}</button>
      <button class="btn-ok" (click)="saveAndExit()" >
        {{'appointments.gui.buttons.save and exit' | translate}} </button>
    </div>
  </div>
</div>
<aside class="l-sidebar l-flex l-column" style="height: 100%;">
    <img class="off-mobile sidebar-logo logo-3d-effect" src="../../assets/icons/logo.svg" alt="Artisan Sonics" />
    <div class="userPanel"></div>
    <app-bar (pageChange)="setPage($event)"></app-bar>
    <nav class="mainNav l-fg1 scroller"></nav>
    <app-docpanel></app-docpanel>
  
  </aside>
  <!-- ========================== header (start) ========================== -->
  <header class="l-header">
  
    <div class="on-mobile header-logo">
      <img src="assets/icons/logo.svg" alt="Artisan Sonics" />
    </div>
    <div class="l-header-panel" style="display: flex;
    flex-direction: row;
    justify-content: space-between;
    
  ">
       <div *ngIf=" page!=='exams' && page!='Sms' && page !='hmoSettings'&& !ls.premissions.ApptsByRoom && page!='Blocks Management' && page!='Sms Tracking' && page!='questionnaires' && page!='Financial Report'" style="right: 10em">
        <div class="l-flex l-flex-c t-field t-field-pad">
          <label matTooltip="שם הרופא">
            <img src="../../assets/icons/drb.svg" />
          </label>
  
          <i class="t-sep"></i>
  
          <span class="t-validation-wrap l-fg1">
            <select
              [(ngModel)]="ls.doctor"
              class="t-select w100"
              style="text-align: center"
            >
            <option *ngIf="page=='Reports'" [ngValue]="null">All</option>
              <ng-container *ngFor="let e of ls.clinicUsers">
                <option [value]="e.UID">{{ e.Name }}</option>
              </ng-container>
            </select>
          </span>
        </div>
      </div>
      <div *ngIf="page!=='exams' && page!='Sms' && page !='hmoSettings'&& page!='Reports' &&  page!='privateSettings'&& page!='performerPriceList' && ls.premissions.ApptsByRoom && page!='Sms Tracking' && page!='questionnaires' && page!='Financial Report'" style="right: 10em">
        <div class="l-flex l-flex-c t-field t-field-pad">
          <label matTooltip="שם החדר">
            <img src="../../assets/icons/drb.svg" />
          </label>
  
          <i class="t-sep"></i>
  
          <span class="t-validation-wrap l-fg1">
            <select
              [(ngModel)]="ls.room"
              class="t-select w100"
              style="text-align: center"
            >
            <!-- <option *ngIf="page=='Reports'" [ngValue]="null">All</option> -->
              <ng-container *ngFor="let r of ls.activeRooms">
                <option [value]="r.AutoIndex">{{ ls.roomLabel(r) }}</option>
              </ng-container>
            </select>
          </span>
        </div>
      </div>
      <div style="display: flex;
      flex-direction: row;
      width: 7%;
      justify-content: space-between;">
        <img *ngIf="ls.premissions?.Appointments"
        style="cursor: pointer"
        [matTooltip]="'appointments.gui.tooltips.Back to Calendar' | translate"
        height="41em"
        width="41em"
        src="../../assets/icons/exit.svg"
        (click)="exit()"
        />

        <img *ngIf="ls.premissions?.Billings && !ls.premissions?.Appointments"
        style="cursor: pointer"
        [matTooltip]="'appointments.gui.tooltips.Back to Billing' | translate"
        height="41em"
        width="41em"
        src="../../assets/icons/exit.svg"
        (click)="goToBilling()"
        />

        <!-- Back to the clinical system the user arrived from (item: entered via code),
             shown alongside the calendar/billing buttons above when applicable, and as
             the only option for a questionnaire-only user with no appointments/billing. -->
        <img *ngIf="ls.enteredViaCode || (!ls.premissions?.Appointments && !ls.premissions?.Billings)"
        style="cursor: pointer"
        [matTooltip]="'appointments.gui.access.Back to system' | translate"
        height="41em"
        width="41em"
        src="../../assets/icons/medical.svg"
        (click)="redirectAdministration()"
        />

    </div>
    </div>
  </header>
  <app-exams-names *ngIf="page=='exams'"></app-exams-names>
  <app-activity-hours *ngIf="page=='Activity Hours'" [selectedUserId]="ls.doctor"></app-activity-hours>
  <app-rooms-activity-hours *ngIf="page=='rooms Activity Hours'"  [selectedRoomId]="ls.room"></app-rooms-activity-hours>
  <app-search *ngIf="page=='Reports'"></app-search>
  <app-sms-settings *ngIf="page=='Sms'"></app-sms-settings>
  <app-price-list *ngIf="page=='privateSettings'"   [selectedUserId]="ls.premissions?.ApptsByRoom ? null : ls.doctor">> </app-price-list>
  <app-hmo-price-list *ngIf="page=='hmoSettings'"></app-hmo-price-list>
  <app-performer-price-list *ngIf="page=='performerPriceList'" [selectedUserId]="ls.doctor"></app-performer-price-list>
  <app-financial-report *ngIf="page=='Financial Report'"></app-financial-report>
  <app-blocks-management *ngIf="page=='Blocks Management'"></app-blocks-management>
  <app-questionnaire-templates *ngIf="page=='questionnaires'"></app-questionnaire-templates>
<app-sms-reminders-tracking *ngIf="page=='Sms Tracking'"></app-sms-reminders-tracking>
  <!-- <app-hmo-quota *ngIf="page=='hmoQuota'"  [selectedUserId]="ls.doctor"></app-hmo-quota> -->
  <app-commerror></app-commerror> 
<app-bottombar></app-bottombar>
